import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Coursera from "../utils/courseraAxiosConfig";
import axios from "axios";
import qs from "qs";
import {
  getCourseContents,
  getCourseContentsDetails,
  getCourseModuleDetailsData,
  getCourseProgress,
  getFilterationData,
} from "../services/courseraServices";
import {
  getAssessmentContents,
  GetAssessmentData,
  GetCarouselData,
  getProjects,
} from "../services/awsServices";
const {
  VITE_APP_COURSERA_ORG_ID,
  VITE_APP_COURSERA_CLIENT_ID,
  VITE_APP_COURSERA_CLIENT_SECRET,
  VITE_APP_COURSERA_GRANT_TYPE,
  VITE_APP_COURSERA_CODE_GENERATE_LINK,
} = import.meta.env;
const initialState = {
  courseData: [],
  courseProgressData: [],
  assessmentData: [],
  courseDetailsData: [],
  courseModulesDetailsData: [],
  filtersData: [],
  assessmentResultData: [],
  projectData: [],
};
export const getCourseraAccessTokenThunk = createAsyncThunk(
  "coursera/getCourseraAccessTokenThunk",
  async (_, thunkAPI) => {
    try {
      // Access the current state
      const state = thunkAPI.getState();
      // Retrieve the refreshToken from the state
      const refreshToken =
        state.coursera.refreshToken ||
        "cPV73HHHH-UU1XW4TAlZpnnhCsKCZ-kxuimarX8f5U0";
      const urlData = {
        VITE_APP_COURSERA_ORG_ID,
        client_id: VITE_APP_COURSERA_CLIENT_ID,
        client_secret: VITE_APP_COURSERA_CLIENT_SECRET,
        // access_type: 'offline',
        grant_type: "refresh_token",
        refresh_token: refreshToken,
        "Content-Type": "application/x-www-form-urlencoded",
      };
      let response = await axios.post(
        `https://accounts.coursera.org/oauth2/v1/token`,
        qs.stringify(urlData),
        headersUrlEncoded
      );
      console.log("Access Token:", response.data.access_token);
      return response.data;
    } catch (err) {
      console.log("Access Token Error:", err);
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const getCourseraRefreshTokenThunk = createAsyncThunk(
  "coursera/getCourseraRefreshTokenThunk",
  async (_, thunkAPI) => {
    try {
      console.log(
        VITE_APP_COURSERA_CODE_GENERATE_LINK,
        " = VITE_APP_COURSERA_CODE_GENERATE_LINK"
      );
      const codeRes = await axios.get(
        `${VITE_APP_COURSERA_CODE_GENERATE_LINK}`,
        { headers: { "Content-Type": "application/json" } }
      );
      console.log(codeRes, " = codeResssssssssssss");
      // Access the current state
      //   const state = thunkAPI.getState();
      //   // Retrieve the refreshToken from the state
      //   const refreshToken = state.coursera.refreshToken;
      //   const urlData = {
      // grant_type: 'authorization_code',
      //     VITE_APP_COURSERA_ORG_ID,
      //     VITE_APP_COURSERA_CLIENT_ID,
      //     VITE_APP_COURSERA_CLIENT_SECRET,
      //     VITE_APP_COURSERA_GRANT_TYPE,
      //     refresh_token: refreshToken,
      //   };
      //   let response = await axios.post(
      //     `https://accounts.coursera.org/oauth2/v1/token`,
      //     qs.stringify(urlData),
      //     headersUrlEncoded
      //   );
      //   console.log("Access Token:", response.data.access_token);
      //   return response.data;
    } catch (err) {
      console.log(err, " = codeResssssssssssss:err");
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const getCourseraContents = createAsyncThunk(
  "coursera/getCourseraContents",
  async (data, thunkAPI) => {
    try {
      const resp = await getCourseContents(data);
      console.log(resp, " =resp: getCourseraContents:slice");
      return resp.data;
    } catch (err) {
      console.log(err, " = codeResssssssssssss:err");
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const getAssessmentContentsData = createAsyncThunk(
  "coursera/getAssessmentContents",
  async (data, thunkAPI) => {
    try {
      const resp = await getAssessmentContents(data);
      console.log(resp, " =resp: getCourseraContents:slice");
      return resp.data;
    } catch (err) {
      console.log(err, " = codeResssssssssssss:err");
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const getCourseraContentsDetails = createAsyncThunk(
  "coursera/getCourseraContentsDetails",
  async (data, thunkAPI) => {
    try {
      console.log(":rocket: ~ data:", data);
      const promisesData = data?.map(async (id) => {
        const resp = getCourseContentsDetails(id.contentId);
        // console.log(resp, " =resp: getCourseraContents:slice");
        return resp;
      });
      console.log(":rocket: ~ promisesData ~ promisesData:", promisesData);
      const results = await Promise.all(promisesData);
      console.log(":rocket: ~ eeeeeeresults:", results);
      return results.map((res) => res.data.data.elements[0]);
    } catch (err) {
      console.log(err, " = codeResssssssssssss:err");
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const getCourseModulesDetailsData = createAsyncThunk(
  "coursera/getCourseModulesDetailsData",
  async (data, thunkAPI) => {
    try {
      const resp = await getCourseModuleDetailsData(data);
      console.log(resp, " =resp: getCourseraContents:slice");
      return resp.data;
    } catch (err) {
      console.log(err, " = codeResssssssssssss:err");
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const getCourseProgressDetails = createAsyncThunk(
  "coursera/getCourseProgressDetails",
  async (data, thunkAPI) => {
    try {
      const resp = await getCourseProgress(data);
      return resp.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const getCarouselImages = createAsyncThunk(
  "coursera/getCarouselImages",
  async (data, thunkAPI) => {
    try {
      const resp = await GetCarouselData(data);
      return resp.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const GetFilteratioData = createAsyncThunk(
  "coursera/GetFilteratioData",
  async (_, thunkAPI) => {
    try {
      const resp = await getFilterationData();
      return resp.data.data;
    }
    catch (error) {
      console.log(error)
      return thunkAPI.rejectWithValue(error);
    }
  }
  )
export const getAssessmentResultData = createAsyncThunk(
  "coursera/getAssessmentResultData",
  async (data, thunkAPI) => {
    try {
      const resp = await GetAssessmentData(data);
      return resp.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const getProjectsData = createAsyncThunk(
  "coursera/getProjectsData",
  async (data, thunkAPI) => {
    try {
      const resp = await getProjects(data);
      return resp.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
const courseraSlice = createSlice({
  initialState,
  name: "coursera",
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCourseraContents.fulfilled, (state, action) => {
      state.courseData = action?.payload?.data;
    });
    builder.addCase(getProjectsData.fulfilled, (state, action) => {
      state.projectData = action?.payload?.data;
    });
    builder.addCase(getAssessmentResultData.fulfilled, (state, action) => {
      state.assessmentResultData = action?.payload?.data;
    });
    builder.addCase(getCourseProgressDetails.fulfilled, (state, action) => {
      state.courseProgressData = action?.payload?.data?.elements;
    });
    builder.addCase(getAssessmentContentsData.fulfilled, (state, action) => {
      state.assessmentData = action?.payload.data.assessments;
    });
    builder.addCase(getCourseraContentsDetails.fulfilled, (state, action) => {
      console.log(action?.payload, " =action?.payloadssss");
      state.courseDetailsData = action?.payload;
    });
    builder.addCase(getCourseModulesDetailsData.fulfilled, (state, action) => {
      console.log(action?.payload, " =action?.payloadssss");
      state.courseModulesDetailsData = action?.payload.data.elements[0].modules;
    });
    builder.addCase(GetFilteratioData.fulfilled, (state, action) => {
      console.log(action?.payload, " =action?.payloadssss");
      state.filtersData = action?.payload
    });
  },
});
// export const {  } = courseraSlice.actions;
export default courseraSlice.reducer;
